import { render, staticRenderFns } from "./AcademyProblems.vue?vue&type=template&id=2b5cd223&scoped=true&lang=pug&"
import script from "./AcademyProblems.vue?vue&type=script&lang=ts&"
export * from "./AcademyProblems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5cd223",
  null
  
)

export default component.exports